import React, { Component, Fragment } from 'react';
import axios from 'axios'
import moment from 'moment';

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import SimpleTable from "../helper/SimpleTable";
import * as API from '../helper/APIcalls';
import { GridAutoTextField } from '../helper/GridComponents';
import { CancelDialog } from '../helper/Dialogs';
import { authContext } from "../../context/AuthContext";

import { languageSearch, languages, types } from '../../constants/global'

import { EnterNewUsedByDate } from '../helper/Dialogs';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

const status = [
    { value:0, label: "Pending"},
    { value:1, label: "Published"},
    { value:2, label: "Cancelled"},
    { value:3, label: "Submmitted to State Office"},
]

const tableCells = [
    //{ id: 'ID', label: 'ID', centered: false }, // not displaying the id
    { id: 'workshopID', label: 'Class ID', centered: false },
    { id: 'date', label: 'Date', centered: false },
    { id: 'location', label: 'Location', centered: false },
    { id: 'status', label: 'Status', centered: false },
    { id: 'language', label: 'Language', centered: false },
    { id: 'leadInstructor', label: 'Lead Instructor', centered: false },
    { id: 'contact', label: 'Contact', centered: false }
];


class WorkshopsAdmin extends Component {
    static contextType = authContext; //used for username for cancellation reason

    constructor(props) {
        super(props);

        let fromStorage = {}
        if (sessionStorage.getItem("workshopSearchState"))
             fromStorage = JSON.parse(sessionStorage.getItem("workshopSearchState"));

        this.state = {
            submitting: false,
            loading: true,
            isLoading: true, // when search

            cancel: {open: false, id: null, }, // the cancel dialog state with reason
            cancelReason: '',


            workshops: [],


            fromDate: moment().subtract(0, 'months').format("YYYY-MM-DD"),
            toDate: '',

            status: null,

            category: null,
            categories: [],

            organization: null,
            organizations: [],
            filteredOrganizations: [],

            open: false,
            deadlineDate: '',
            valid: false,
            usedBy: '',
            ID:'',
            serialNumber: '',
            trainingType: '',

            leadInstructor: null,
            createdBy: null,
            presenter: null,
            leadInstructors: [],

            locName: '',
            county: null,
            city: '',
            counties: [],

            language: -1,
            type: -1,
            error: null,
            id: null,
            classID: '',
            enhancedData: [],
            ...fromStorage
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    // onChange = event => {
    //     this.setState({
    //         [event.target.name]: event.target.value
    //     });
    // }

    onSelectChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    onView = (tag) => {
        let workshopID = tag;

        this.props.history.push({
            pathname: '/class/' + workshopID + '/view'
        });
    }

    onEdit = (tag) => {
        let workshopID = tag;

        this.props.history.push({
            pathname: '/class/' + workshopID,
            state: {
                editing: true,
            }
        });
    }

    // opens dialog
    onCancel = (workshopID) => {
        this.setState({cancel : {open: true, id: workshopID}})    }


    // closes dialog
    onCancelClose = () => {
        this.setState({cancel : {open: false, id: null}})
    }

    // submits reason from dialog and reloads workshops
    handleCancel = async () => {
        if (this.state.submitting)
            return;

        this.setState({submitting: true});
        const options = await API.getTrainingProviderOptions()

        const data = await API.getWorkshopData(this.state.cancel.id, options, languages)

        await API.cancelWorkshop(this.state.cancel.id, this.state.cancelReason, this.context.user.username, data)

        // reloads classes so that the new status is displayed, could also just set the status from here instead of reload
        this.refresh()
        this.setState({submitting: false})

        this.onCancelClose()
    }
    // handles textfield update for reason
    handleReason = (event) => {
        this.setState({cancelReason: event.target.value})
    }

    onSearch = (event) => {
        this.refresh();
    }

    onAddWorkshop = (event) => {
        this.props.history.push({
            pathname: '/class'
        });
    }

    onWaive = (workshopID) => {
        this.props.history.push({
            pathname: '/class/' + workshopID + '/waive'
        });
    }

    

    async refresh() {
        console.log("In refresh")
        console.log(this.state.classID);
        axios.get('/api/workshop/search', {
            params: {
                fromDate: this.state.fromDate,
                language: this.state.language,
                type: this.state.type,

                organizationId: this.state.organization && this.state.organization.value,
                categoryId: this.state.category && this.state.category.value,
                createdBy: this.state.createdBy && this.state.createdBy.value,
                leadInstructorId: this.state.leadInstructor && this.state.leadInstructor.value,
                status: this.state.status && this.state.status.value,

                toDate: this.state.toDate!=='' ? this.state.toDate : null,
                locCounty: this.state.county && this.state.county.value,
                locCity: this.state.city!=='' ? this.state.city : null,
                locName: this.state.locName!=='' ? this.state.locName : null,

                presenter: this.state.presenter && this.state.presenter.value,

                classID: this.state.classID !=='' ? this.state.classID : null,
            }
        }).then((res) => {
            console.log(res)
            console.log('workshop data', res.data.workshops)
            this.setState({
                workshops: res.data.workshops,
                isLoading: false
            });

            let enhancedData = [];
            enhancedData = this.state.workshops.map((arrayItem) => {
                let item = JSON.parse(JSON.stringify(arrayItem))
                item.date = moment(item.fromDate).format('YYYY-MM-DD');
                item.location = item.isRemote ? "Live Online Session" : item.location;
                item.actionsDisabled = {
                    allowView: true,
                    allowEdit: item.status !== "Cancelled", //disable on cancel
                    allowCancel: item.status !== "Cancelled",
                    allowWaiver: item.status === "Pending", //!item.waiverNeeded, //false, 
                    allowDeadline: item.trainingCode !== null,
                    allowAttendess: item.trainingCode !== null
                }
                // console.log("WaiverNeeded?",item.waiverNeeded)
                return item;
            });
            this.setState({
                enhancedData: enhancedData
            })

        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                isLoading: false,
                error: error.message
            });
        });


    }

    hideError = () => {
        this.setState({ error: '' })
    }

    async componentDidMount() {
        // if there is not an existing list, then search for it
        if(this.state.workshops.length === 0)
            this.refresh();

        //grab and set options
        const options = await API.getWorkshopAdminSearchOptions()
        this.setState(options)

        if(this.state.workshops.length !== 0) this.setState({ loading: false, isLoading: false})
        else this.setState({ loading: false, })
         
    }

    componentWillUnmount() {
        const toSave = {
                // workshops: this.state.workshops, //don't save the workshops list, if saved won't update if a workshop is changed
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                status: this.state.status,
                category: this.state.category,
                organization: this.state.organization,
                leadInstructor: this.state.leadInstructor,
                createdBy: this.state.createdBy,
                presenter: this.state.presenter,
                locName: this.state.locName,
                county: this.state.county,
                city: this.state.city,
                language: this.state.language,
                type: this.state.type,
        }
        sessionStorage.setItem("workshopSearchState", JSON.stringify(toSave));

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    setFilteredOrgs = (cat) => {
        let filteredOrgs = []
        if (cat !== null) {
            filteredOrgs = this.state.organizations.filter(org => org.categoryId === cat.value)
        }
        this.setState({ filteredOrganizations: filteredOrgs })
    }

    onCategoryChange = (cat) => {
        this.setFilteredOrgs(cat)

        // clears organization ID (beacuse category changed, old organization no longer valid) (catvalue is string, org cat id is int)
        this.setState({ organization: null })
    }

    onChange = (event) => {
        const { name, value } = event.target

        this.setState({
            [name]: value
        });

        // if the category is changing, update the filtered orgs with the correct category ID
        if (name === "category") {
            this.onCategoryChange(value)
        }
    }

    handleDateProcessed = (event) => {
        event.persist()
        let date = moment(event.target.value);
        console.log('date validity', date.isValid() )
        console.log('used By date', event.target.value )
        this.setState({
            valid : date.isValid(),
            usedBy : event.target.value
        })
        // setValid(date.isValid());
        // setNewUsedByDetails( prev => {return {...prev, usedBy: event.target.value}})
        console.log('date processed', this.state.usedBy);
    }

    handleClose = () => {
        // setOpen(false);
        this.setState({
            open :false
        })
      };

    handleRefundClick = async () => {
        
        // console.log('data to be sent to server', newusedByDetails );

        // let token = context.accessToken;
        let token = sessionStorage.getItem('accessToken');
        console.log('useBy date send', this.state.usedBy )
        let data = {
            usedBy: this.state.usedBy

        }

        console.log(data);

    //     const res = await axios('/api/trainingCode/' + newusedByDetails.ID , {
    //         method: 'POST',
    //         data: JSON.stringify(data.usedBy),
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': token
    //         }
    //     })
    //    // reloads user credit log
        console.log('state id', this.state.ID )
        let res = await axios.post('/api/trainingCode/'+ this.state.ID ,{
            usedBy : this.state.usedBy
        },{
            headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
        } )
       console.log('res', res);
       console.log("closing dialog");
       this.handleClose()
        // getData()


        
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
      };

      handleInvalid=(errors)=>{
        // this focuses on the first component with a validation error
        console.log('error handler')

        this.setState({
            workshops: [],
            enhancedData: []
        })

        const focusElem = document.getElementsByName(errors[0].props.name)
        if(focusElem.length === 1)
            focusElem[0].focus()
        
        // it seems like if it finds an autocomplete, there is a div and then an input with the same name. .focus does not seem to work on the div's
        else
            focusElem[1].focus()
            
        // console.log(errors)
        // console.log(errors[0].props.name)

    }

    handleClearSearch =() => {
        console.log('clear search')
        this.setState({

            workshops: [],

            fromDate: moment().subtract(0, 'months').format("YYYY-MM-DD"),
            toDate: '',

            status: null,

            category: null,

            organization: null,

            leadInstructor: null,
            createdBy: null,
            presenter: null,

            locName: '',
            county: null,
            city: '',

            language: -1,
            type: -1,
            classID: '',
            enhancedData: [],
        })
    }

    onAttendess = async (id) => {

        console.log('clicked on', id)
        const item = this.state.enhancedData.find(e => e.ID === id)
        console.log('item', item.trainingCode )

        this.props.history.push({
            pathname: '/dashboard/trainingProvider/manageClasses/attendess/'+ item.trainingCode,
            state: {
                fromDate: item.fromDate,
                classid: item.workshopID
             }
        });

    }

    onRefundUpdate = async (id) => {
        console.log('enhanced data', this.state.enhancedData)
        const creditLog = this.state.enhancedData.find(e => e.ID === id)
        console.log('creditlog', creditLog);
        const res = await axios.get('/api/trainingCode/'+creditLog.trainingCode, {
        });
        console.log('res training type', res)
        
        this.setState({
            ID: res.data.id,
            usedBy: res.data.usedBy,
            serialNumber:creditLog.trainingCode,
            trainingType:res.data.type 
        })
        // setNewUsedByDetails( prev => {return {...prev, ID: creditLog.id, usedBy: creditLog.usedBy, serialNumber:creditLog.serialNumber, trainingType:creditLog.type  }})
        // console.log(newusedByDetails);
        this.handleClickOpen();
        // if(creditLog.action === "Refund Credit"){
           
        // } 

    }



    



    render() {
        const { classes } = this.props;

        // if (this.state.error) {
        //     return <div>
        //         <br />
        //         <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
        //         <br />
        //     </div>
        // }

        // if (this.state.error !== null) return <Error />;

        if (this.state.isLoading) return <Loading />;

        const actionButtons = [
            { icon: "view", action: this.onView, delete: false, view:"allowView" },
            { icon: "edit", action: this.onEdit, delete: false , view:"allowEdit"},
            { icon: "cancel", action: this.onCancel, delete: false , view:"allowCancel"},
            { icon: "deadline", action: this.onRefundUpdate, delete: false, view:"allowDeadline" },
            { icon: "waiver", action: this.onWaive, delete: false , view:"allowWaiver"},
            { icon: "profile", label: 'Attendess',  action: this.onAttendess, delete: false , view:"allowAttendess"},
        ];

        return (
            <Fragment>
                { console.log('error', this.state.error) }

                         <ValidatorForm
                    noValidate
                    onError={this.handleInvalid} //called on a validation error, used to focus the first element
                    onSubmit={this.onSearch}
                >

                <PageHeader
                    title={"Classes (Admin)"}
                    actionButtons={[{ label: "Add new class", action: this.onAddWorkshop }]}
                />

                <div>
                    <div className={classes.root}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                {/* <TextField
                                    id="fromDate"
                                    label="From"
                                    type="date"
                                    name='fromDate'
                                    value={this.state.fromDate}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.onChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    required
                                /> */}
                                <TextValidator
                                    id="fromDate"
                                    label="From"
                                    type="date"
                                    name='fromDate'
                                    value={this.state.fromDate}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.onChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    validators={['required']}
                                    errorMessages={['From Date is required']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="toDate"
                                    label="To"
                                    type="date"
                                    name='toDate'
                                    value={this.state.toDate}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.onChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                />
                            </Grid>
                             <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="status"
                                options={status}
                                value={this.state.status}
                                onChange={this.onChange}
                                classes={classes}
                                label="Status"
                            />
                             <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="category"
                                options={this.state.categories}
                                value={this.state.category}
                                onChange={this.onChange}
                                classes={classes}
                                label="Category"
                                
                            />
                             <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="organization"
                                options={this.state.filteredOrganizations}
                                value={this.state.organization}
                                onChange={this.onChange}
                                classes={classes}
                                label="Organization"
                                disabled={this.state.category === null}
                            />
                            
                             <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="leadInstructor"
                                options={this.state.leadInstructors}
                                value={this.state.leadInstructor}
                                onChange={this.onChange}
                                classes={classes}
                                label="Lead Instructor"
                            />
                             <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="createdBy"
                                options={this.state.leadInstructors}
                                value={this.state.createdBy}
                                onChange={this.onChange}
                                classes={classes}
                                label="Created By"
                            />
                             <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="presenter"
                                options={this.state.leadInstructors}
                                value={this.state.presenter}
                                onChange={this.onChange}
                                classes={classes}
                                label="Presenter"
                            />
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="locName"
                                    label="Location Name"
                                    type="text"
                                    name='locName'
                                    value={this.state.locName}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.onChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                />
                            </Grid>
                             <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="county"
                                options={this.state.counties}
                                value={this.state.county}
                                onChange={this.onChange}
                                classes={classes}
                                label="Location County"
                            />
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="city"
                                    label="Location City"
                                    type="text"
                                    name='city'
                                    value={this.state.city}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.onChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="language"
                                    name="language"
                                    className={[classes.textField].join(' ')}
                                    value={this.state.language}
                                    onChange={this.onSelectChange}
                                    select
                                    fullWidth
                                    label="Language"
                                >
                                    {languageSearch.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="type"
                                    name="type"
                                    className={[classes.textField].join(' ')}
                                    value={this.state.type}
                                    onChange={this.onSelectChange}
                                    select
                                    fullWidth
                                    label="Public or Private?"
                                >
                                    {types.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="classID"
                                    label="Class ID"
                                    type="text"
                                    name='classID'
                                    value={this.state.classID}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.onChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                >
                                <Grid item md={1} sm={2} xs={4} >
                                    <Button variant="contained" color="primary" type="submit" className={[].join(' ')} onClick={this.onSearch} >Search</Button>
                                </Grid>
                                <Grid item md={1} sm={2} xs={4} >
                                    <Button variant="contained" color="primary" className={[].join(' ')} onClick={this.handleClearSearch} > Clear </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        <br /><br />

                        {this.state.workshops.length === 0
                            ?
                            <Box display="flex" mt={4} justifyContent="center">
                                <h1>No Data</h1>
                            </Box>
                            :
                            <>
                            <SimpleTable
                                data={this.state.enhancedData}
                                cellKey={"ID"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={true}
                            />
                            <CancelDialog
                                open={this.state.cancel.open}
                                onClose={this.onCancelClose}
                                onDelete={this.handleCancel}
                                onChange={this.handleReason}
                                disabled={this.state.submitting}
                                value={this.state.cancelReason}
                            />
                             <EnterNewUsedByDate 
                                open={this.state.open}
                                serialNumber={this.state.serialNumber}
                                trainingType={this.state.trainingType}
                                usedBy={this.state.usedBy}
                                onClose={this.handleClose}
                                onDateChange = {this.handleDateProcessed}
                                onRefundClick = {this.handleRefundClick}
                                valid = {this.state.valid}
                                />
                            </>
                        }
                    </div>
                </div>
                </ValidatorForm >
            </Fragment>
        );
    }
}

// export default WorkshopsAdmin;
export default withStyles(styles, { withTheme: true })(WorkshopsAdmin);
